import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_CONTROLE_CONTA_BANCO_SUCCESS,
    FIND_CONTROLE_CONTA_BANCO_PENDING,
    FIND_CONTROLE_CONTA_BANCO_SUCCESS,
    FIND_CONTROLE_CONTA_BANCO_FAILURE,
    DELETE_CONTROLE_CONTA_BANCO_PENDING,
    DELETE_CONTROLE_CONTA_BANCO_SUCCESS,
    DELETE_CONTROLE_CONTA_BANCO_FAILURE,
    CREATE_CONTROLE_CONTA_BANCO_PENDING,
    CREATE_CONTROLE_CONTA_BANCO_SUCCESS,
    CREATE_CONTROLE_CONTA_BANCO_FAILURE,
    NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_BANCO_PENDING,
    NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_BANCO_SUCCESS,
    NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_BANCO_FAILURE,
    NEW_FILTER_CONTROLE_CONTA_BANCO_PEDING,
    NEW_FILTER_CONTROLE_CONTA_BANCO_SUCCESS,
    NEW_FILTER_CONTROLE_CONTA_BANCO_FAILURE,
    GET_TOTAIS_CONTROLE_CONTA_BANCO_PENDING,
    GET_TOTAIS_CONTROLE_CONTA_BANCO_SUCCESS,
    GET_TOTAIS_CONTROLE_CONTA_BANCO_FAILURE,
    NEW_FILTER_CONTROLE_CONTA_BANCO_SUCCESS_PDF,
} from './actionTypes';

const initialState = {
    list: null,
    loading: false,
    loadingTotais: false,
    filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' },
    totais: {
        totalSadoAnterior: 0,
        totalEntrada: 0,
        totalSaida: 0,
        totalFinal: 0
    }
}

function controleContaBancoReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CONTROLE_CONTA_BANCO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case FIND_CONTROLE_CONTA_BANCO_PENDING:
        case DELETE_CONTROLE_CONTA_BANCO_PENDING:
        case CREATE_CONTROLE_CONTA_BANCO_PENDING:
        case NEW_FILTER_CONTROLE_CONTA_BANCO_PEDING:
        case NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_BANCO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CONTROLE_CONTA_BANCO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CONTROLE_CONTA_BANCO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CONTROLE_CONTA_BANCO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case GET_TOTAIS_CONTROLE_CONTA_BANCO_PENDING:
            return {
                ...state,
                loadingTotais: true,
            }
        case GET_TOTAIS_CONTROLE_CONTA_BANCO_SUCCESS:
            return {
                ...state,
                totais: action.totais,
                loadingTotais: false
            }
        case GET_TOTAIS_CONTROLE_CONTA_BANCO_FAILURE:
            return {
                ...state,
                totais: {
                    totalSadoAnterior: 0,
                    totalEntrada: 0,
                    totalSaida: 0,
                    totalFinal: 0
                },
                loadingTotais: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_BANCO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_BANCO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_CONTROLE_CONTA_BANCO_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_CONTROLE_CONTA_BANCO_SUCCESS_PDF:
        case NEW_FILTER_CONTROLE_CONTA_BANCO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CONTROLE_CONTA_BANCO_SUCCESS:
        case CREATE_CONTROLE_CONTA_BANCO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_CONTROLE_CONTA_BANCO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { controleContaBancoReducer };